import * as React from 'react'
import {
  useForm,
  UseFormRegister,
  UseFormGetValues,
  UseFormSetValue,
} from 'react-hook-form'

import {
  SearchConditionRegularDate as SearchConditionRegularDatePresenter,
  IProps as IPresenterProps,
} from './presenter'
import {
  trackingUserContext,
  searchEventIdContext,
} from '@/contexts/trackingContexts'
import { trackEvent } from '@/utils/analyze'

const weeks: WeekType[] = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
]

interface IProps
  extends Omit<
    IPresenterProps,
    | 'resetHandler'
    | 'submitHandler'
    | 'resetHandler'
    | 'register'
    | 'setWorkTimeFromHandler'
    | 'setWorkTimeToHandler'
    | 'setWorkTimeFromUnselectedHandler'
    | 'setWorkTimeToUnselectedHandler'
    | 'weeks'
    | 'setWeekHandler'
    | 'getValues'
    | 'regularSearch'
    | 'disableButton'
  > {
  getParentValues: UseFormGetValues<ISearchConditionState>
  submitHandler: (state: ISearchRegularState) => void
  register: UseFormRegister<ISearchConditionState>
  prevHandler: () => void
}

const resetValues = {
  regular_search: {
    sunday: 0,
    sunday_work_time_from: '12:00',
    sunday_work_time_to: '13:00',
    sunday_work_time_from_unselected: 0,
    sunday_work_time_to_unselected: 0,
    monday: 0,
    monday_work_time_from: '12:00',
    monday_work_time_to: '13:00',
    monday_work_time_from_unselected: 0,
    monday_work_time_to_unselected: 0,
    tuesday: 0,
    tuesday_work_time_from: '12:00',
    tuesday_work_time_to: '13:00',
    tuesday_work_time_from_unselected: 0,
    tuesday_work_time_to_unselected: 0,
    wednesday: 0,
    wednesday_work_time_from: '12:00',
    wednesday_work_time_to: '13:00',
    wednesday_work_time_from_unselected: 0,
    wednesday_work_time_to_unselected: 0,
    thursday: 0,
    thursday_work_time_from: '12:00',
    thursday_work_time_to: '13:00',
    thursday_work_time_from_unselected: 0,
    thursday_work_time_to_unselected: 0,
    friday: 0,
    friday_work_time_from: '12:00',
    friday_work_time_to: '13:00',
    friday_work_time_from_unselected: 0,
    friday_work_time_to_unselected: 0,
    saturday: 0,
    saturday_work_time_from: '12:00',
    saturday_work_time_to: '13:00',
    saturday_work_time_from_unselected: 0,
    saturday_work_time_to_unselected: 0,
  },
}

export const SearchConditionRegularDate = ({
  getParentValues,
  prevHandler,
  ...props
}: IProps): JSX.Element => {
  const user = React.useContext(trackingUserContext)
  const eventIds = React.useContext(searchEventIdContext)

  const defaultValues = {
    regular_search: {
      sunday:
        getParentValues('regular_search.sunday') !== undefined
          ? getParentValues('regular_search.sunday')
          : 0,
      sunday_work_time_from:
        getParentValues('regular_search.sunday_work_time_from') !== undefined
          ? getParentValues('regular_search.sunday_work_time_from')
          : '12:00',
      sunday_work_time_to:
        getParentValues('regular_search.sunday_work_time_to') !== undefined
          ? getParentValues('regular_search.sunday_work_time_to')
          : '13:00',
      sunday_work_time_from_unselected:
        getParentValues('regular_search.sunday_work_time_from_unselected') !==
        undefined
          ? getParentValues('regular_search.sunday_work_time_from_unselected')
          : 0,
      sunday_work_time_to_unselected:
        getParentValues('regular_search.sunday_work_time_to_unselected') !==
        undefined
          ? getParentValues('regular_search.sunday_work_time_to_unselected')
          : 0,

      monday:
        getParentValues('regular_search.monday') !== undefined
          ? getParentValues('regular_search.monday')
          : 0,
      monday_work_time_from:
        getParentValues('regular_search.monday_work_time_from') !== undefined
          ? getParentValues('regular_search.monday_work_time_from')
          : '12:00',
      monday_work_time_to:
        getParentValues('regular_search.monday_work_time_to') !== undefined
          ? getParentValues('regular_search.monday_work_time_to')
          : '13:00',
      monday_work_time_from_unselected:
        getParentValues('regular_search.monday_work_time_from_unselected') !==
        undefined
          ? getParentValues('regular_search.monday_work_time_from_unselected')
          : 0,
      monday_work_time_to_unselected:
        getParentValues('regular_search.monday_work_time_to_unselected') !==
        undefined
          ? getParentValues('regular_search.monday_work_time_to_unselected')
          : 0,

      tuesday:
        getParentValues('regular_search.tuesday') !== undefined
          ? getParentValues('regular_search.tuesday')
          : 0,
      tuesday_work_time_from:
        getParentValues('regular_search.tuesday_work_time_from') !== undefined
          ? getParentValues('regular_search.tuesday_work_time_from')
          : '12:00',
      tuesday_work_time_to:
        getParentValues('regular_search.tuesday_work_time_to') !== undefined
          ? getParentValues('regular_search.tuesday_work_time_to')
          : '13:00',
      tuesday_work_time_from_unselected:
        getParentValues('regular_search.tuesday_work_time_from_unselected') !==
        undefined
          ? getParentValues('regular_search.tuesday_work_time_from_unselected')
          : 0,
      tuesday_work_time_to_unselected:
        getParentValues('regular_search.tuesday_work_time_to_unselected') !==
        undefined
          ? getParentValues('regular_search.tuesday_work_time_to_unselected')
          : 0,

      wednesday:
        getParentValues('regular_search.wednesday') !== undefined
          ? getParentValues('regular_search.wednesday')
          : 0,
      wednesday_work_time_from:
        getParentValues('regular_search.wednesday_work_time_from') !== undefined
          ? getParentValues('regular_search.wednesday_work_time_from')
          : '12:00',
      wednesday_work_time_to:
        getParentValues('regular_search.wednesday_work_time_to') !== undefined
          ? getParentValues('regular_search.wednesday_work_time_to')
          : '13:00',
      wednesday_work_time_from_unselected:
        getParentValues(
          'regular_search.wednesday_work_time_from_unselected',
        ) !== undefined
          ? getParentValues(
              'regular_search.wednesday_work_time_from_unselected',
            )
          : 0,
      wednesday_work_time_to_unselected:
        getParentValues('regular_search.wednesday_work_time_to_unselected') !==
        undefined
          ? getParentValues('regular_search.wednesday_work_time_to_unselected')
          : 0,

      thursday:
        getParentValues('regular_search.thursday') !== undefined
          ? getParentValues('regular_search.thursday')
          : 0,
      thursday_work_time_from:
        getParentValues('regular_search.thursday_work_time_from') !== undefined
          ? getParentValues('regular_search.thursday_work_time_from')
          : '12:00',
      thursday_work_time_to:
        getParentValues('regular_search.thursday_work_time_to') !== undefined
          ? getParentValues('regular_search.thursday_work_time_to')
          : '13:00',
      thursday_work_time_from_unselected:
        getParentValues('regular_search.thursday_work_time_from_unselected') !==
        undefined
          ? getParentValues('regular_search.thursday_work_time_from_unselected')
          : 0,
      thursday_work_time_to_unselected:
        getParentValues('regular_search.thursday_work_time_to_unselected') !==
        undefined
          ? getParentValues('regular_search.thursday_work_time_to_unselected')
          : 0,

      friday:
        getParentValues('regular_search.friday') !== undefined
          ? getParentValues('regular_search.friday')
          : 0,
      friday_work_time_from:
        getParentValues('regular_search.friday_work_time_from') !== undefined
          ? getParentValues('regular_search.friday_work_time_from')
          : '12:00',
      friday_work_time_to:
        getParentValues('regular_search.friday_work_time_to') !== undefined
          ? getParentValues('regular_search.friday_work_time_to')
          : '13:00',
      friday_work_time_from_unselected:
        getParentValues('regular_search.friday_work_time_from_unselected') !==
        undefined
          ? getParentValues('regular_search.friday_work_time_from_unselected')
          : 0,
      friday_work_time_to_unselected:
        getParentValues('regular_search.friday_work_time_to_unselected') !==
        undefined
          ? getParentValues('regular_search.friday_work_time_to_unselected')
          : 0,

      saturday:
        getParentValues('regular_search.saturday') !== undefined
          ? getParentValues('regular_search.saturday')
          : 0,
      saturday_work_time_from:
        getParentValues('regular_search.saturday_work_time_from') !== undefined
          ? getParentValues('regular_search.saturday_work_time_from')
          : '12:00',
      saturday_work_time_to:
        getParentValues('regular_search.saturday_work_time_to') !== undefined
          ? getParentValues('regular_search.saturday_work_time_to')
          : '13:00',
      saturday_work_time_from_unselected:
        getParentValues('regular_search.saturday_work_time_from_unselected') !==
        undefined
          ? getParentValues('regular_search.saturday_work_time_from_unselected')
          : 0,
      saturday_work_time_to_unselected:
        getParentValues('regular_search.saturday_work_time_to_unselected') !==
        undefined
          ? getParentValues('regular_search.saturday_work_time_to_unselected')
          : 0,
    },
  }

  const useFormObject = useForm<ISearchRegularState>({
    defaultValues: defaultValues,
  })
  const { register, setValue, watch } = useFormObject
  const getValues = useFormObject.getValues
  const regularSearch = watch()

  const setWeekHandler = (week: WeekType, value: number) => {
    if (!weeks.includes(week)) {
      return
    }
    setValue(`regular_search.${week}`, value)
  }

  const setWorkTimeFromHandler = (week: WeekType, value: string) => {
    setValue(`regular_search.${week}_work_time_from`, value)
  }

  const setWorkTimeFromUnselectedHandler = (week: WeekType, value: number) => {
    if (!weeks.includes(week)) {
      return
    }
    setValue(`regular_search.${week}_work_time_from_unselected`, value)
  }

  const setWorkTimeToHandler = (week: WeekType, value: string) => {
    setValue(`regular_search.${week}_work_time_to`, value)
  }

  const setWorkTimeToUnselectedHandler = (week: WeekType, value: number) => {
    if (!weeks.includes(week)) {
      return
    }
    setValue(`regular_search.${week}_work_time_to_unselected`, value)
  }

  const submitHandler = () => {
    if (disableButton()) {
      trackEvent(eventIds.SEARCH_MODAL_DATE_SUBMIT, user)
      props.submitHandler({ regular_search: getValues('regular_search') })
    }
  }

  const resetHandler = () => {
    setValue('regular_search', resetValues.regular_search)
  }

  const disableButton = () => {
    return weeks.every((week: WeekType) => {
      const work = regularSearch.regular_search[`${week}`] === 1
      const workTimeFrom =
        regularSearch.regular_search[`${week}_work_time_from`]
      const workTimeTo = regularSearch.regular_search[`${week}_work_time_to`]
      const workTimeFromUnselected =
        regularSearch.regular_search[`${week}_work_time_from_unselected`]
      const workTimeToUnselected =
        regularSearch.regular_search[`${week}_work_time_to_unselected`]
      if (
        work &&
        workTimeFrom >= workTimeTo &&
        !workTimeFromUnselected &&
        !workTimeToUnselected
      ) {
        return false
      }
      return true
    })
  }

  return (
    <SearchConditionRegularDatePresenter
      {...props}
      weeks={weeks}
      prevHandler={prevHandler}
      register={register}
      submitHandler={submitHandler}
      resetHandler={resetHandler}
      getValues={getValues}
      regularSearch={regularSearch}
      disableButton={disableButton}
      setWeekHandler={setWeekHandler}
      setWorkTimeFromHandler={setWorkTimeFromHandler}
      setWorkTimeFromUnselectedHandler={setWorkTimeFromUnselectedHandler}
      setWorkTimeToHandler={setWorkTimeToHandler}
      setWorkTimeToUnselectedHandler={setWorkTimeToUnselectedHandler}
    />
  )
}
